import React from 'react'
import {Link} from "react-router-dom";

function About() {
    return (
        <div className="about">
            <Link>
            <h1>Why this website isn't mobile responsive</h1>
                 <hr/>
            <p>Because i dont want to make it mobile responsive</p>
            </Link>
            
        </div>
    )
}

export default About
